import React, { useEffect, useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import api from "../../services/api";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import {
  TrashIcon,
  DownloadIcon,
} from "@radix-ui/react-icons";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "../../components/ui/alert-dialog";
import { Calendar as CalendarIcon } from "lucide-react";

import { cn } from "../../lib/utils";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../components/ui/popover";

// import { Button } from "primereact/button";
import { Button } from "../../components/ui/button";

import { makeStyles } from "@material-ui/core/styles";
import {
  Typography,
  Divider,
} from "@material-ui/core";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";

import "./styles.css";

import { useAlert } from "react-alert";
import { Calendar as DatePicker } from "primereact/calendar";
import { useParams } from "react-router-dom";
import { Calendar } from "../ui/calendar";
import { ToastAction } from "../ui/toast";
import { useToast } from "../../components/ui/use-toast";
import { ArrowLeftIcon } from "@radix-ui/react-icons";
import Moment from "react-moment";
import { format } from "date-fns";
import UserContext from "src/context/UserContext";
import { stepsNovaAta, stepsEdicaoAta } from "../Tour/steps";
import { useTour } from "@reactour/tour";
import Tour from "../Tour";

const useStyles = makeStyles({
  inputStyle: {
    margin: "5px",
  },
  inputClienteStyle: {
    margin: "5px",
    width: "500px",
  },
  buttonStyle: {
    margin: "5px",
    marginTop: "30px",
    marginBottom: "30px",
  },
  titleStyle: {
    margin: "15px",
  },
  smallTitleStyle: {
    margin: "10px",
    color: "#002884",
  },
  smallerTitleStyle: {
    marginLeft: "12px",
    marginTop: "12px",
  },
  dividerStyle: {
    margin: "25px",
    color: "#006998",
  },
  iconStyle: {
    fontSize: "12px",
  },
  descriptionIconStyle: {
    color: "#388e3c",
  },
});

function NovaAta() {
  const { userData } = useContext(UserContext);
  const history = useHistory();
  const classes = useStyles();
  const alert = useAlert();

  const [participantesFN, setParticipantesFN] = useState([{ emailFN: "" }]);
  const [loading, setLoading] = useState(false);
  const [isDocument, setIsDocument] = useState(false);
  const [customFields, setCustomFields] = useState({});

  const handleCustomFieldChange = (key, value) => {
    setCustomFields((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const [participantesClientes, setParticipantesClientes] = useState([
    { emailCliente: "" },
  ]);

  const [date, setDate] = useState(new Date());

  const { toast } = useToast();

  const [projeto, setNomeProjetos] = useState([]);
  const [idProjeto, setIdProjeto] = useState("");

  const [projetoSelected, setProjetoSelected] = useState("");

  const handleChangeProjeto = (props) => {
    const objetoProjetoSelecionado = projeto.find(
      (item) => item.nome_projeto === props
    );

    setIdProjeto(objetoProjetoSelecionado.id_projeto);
    setProjetoSelected(props);
  };

  const { ataId } = useParams();

  const [cliente, setCliente] = useState([]);
  const [clienteSelected, setClienteSelected] = useState("");
  const [colaboradores, setColaboradores] = useState([]);

  const handleChangeCliente = (props) => {
    setClienteSelected(props);
  };

  const [pontosAbordados, setPontosAbordados] = useState([
    {
      item: "",
      editorValue: "",
    },
  ]);

  const handleAddPontoAbordado = () => {
    setPontosAbordados([...pontosAbordados, { item: "", editorValue: "" }]);
  };

  const handleRemovePontoAbordado = (index) => {
    if (pontosAbordados.length > 1) {
      const updatedPontosAbordados = pontosAbordados.filter(
        (_, i) => i !== index
      );
      setPontosAbordados(updatedPontosAbordados);
    }
  };

  const [proximosPassos, setProximosPassos] = useState([
    {
      atividade: "",
      editorValue: "",
      responsavel: "",
      linkAtividades: "",
      prazo: new Date(),
    },
  ]);

  const [tempoInicial, setTempoInicial] = useState(null);

  const [tempoFinal, setTempoFinal] = useState(null);

  const [duracao, setDuracao] = useState(null);

  const calcularDuracaoHorasArredondadas = (inicio, fim) => {
    if (inicio && fim && fim > inicio) {
      const diff = Math.abs(fim.getTime() - inicio.getTime());
      const horas = diff / (1000 * 60 * 60);
      const horasArredondadas = Math.round(horas);
      setDuracao(horasArredondadas);
    } else {
      setDuracao(null);
    }
  };

  const handleTempoInicialChange = (e) => {
    setTempoInicial(e.value);
    calcularDuracaoHorasArredondadas(e.value, tempoFinal);
  };

  const handleTempoFinalChange = (e) => {
    setTempoFinal(e.value);
    calcularDuracaoHorasArredondadas(tempoInicial, e.value);
  };

  useEffect(() => {
    if (!ataId) {
      setIsEnabledEditionMode(true);
    }
  }, [ataId]);

  let token = localStorage.getItem("auth-token");

  useEffect(() => {
    const buscarAta = async () => {
      try {
        let response;
        let fromDocument = false;
        try {
          // primeiro verifica se é uma ata
          response = await api.get(`/api/ata/minhas/${ataId}`, {
            headers: {
              "X-Auth-Token": token,
              "content-type": "application/json",
            },
          });
          fromDocument = false;
        } catch (error) {
          // se não achar a ata, verifica se é um documento
          if (error.response && error.response.status === 404) {
            try {
              response = await api.get(`/documentos/${ataId}`, {
                headers: {
                  "X-Auth-Token": token,
                  "content-type": "application/json",
                },
              });
              fromDocument = true;
            } catch (docError) {
              console.error("Erro ao buscar documento personalizado:", docError);
              throw error; 
            }
          } else {
            throw error;
          }
        }

        const ata = response.data;
        setIsDocument(fromDocument);

        if (fromDocument) {
          setCustomFields(ata.fields || {});
          setClienteSelected("");
          setProjetoSelected(ata.projeto?.nome || "");
          setDate(new Date(ata.date?.$date || ata.date));
        } else {
          setClienteSelected(ata.cliente);
          setProjetoSelected(ata.projeto);
          setDuracao(ata.duracao);
          setDate(new Date(ata.date?.$date || ata.date));
          setParticipantesFN(ata.participantesFN || []);
          setParticipantesClientes(ata.participantesClientes || []);
          setPontosAbordados(ata.pontosAbordados || []);
          setDecisoes(ata.decisoesTomadas || []);
          setProximosPassos(
            (ata.proximosPassos || []).map((passo) => ({
              ...passo,
              prazo: new Date(passo.prazo?.$date || passo.prazo),
            }))
          );
          setTempoInicial(ata.tempoInicial ? new Date(ata.tempoInicial?.$date || ata.tempoInicial) : null);
          setTempoFinal(ata.tempoFinal ? new Date(ata.tempoFinal?.$date || ata.tempoFinal) : null);
        }
        setLoading(true);
      } catch (error) {
        console.error("Erro ao buscar ata:", error);
      }
    };

    if (ataId) buscarAta();
    else setLoading(true);
  }, [ataId, token]);

  useEffect(() => {
    const buscarProjetosClientes = async () => {
      if (userData.user) {
        let token = localStorage.getItem("auth-token");
        try {
          const response = await api.get("/api/buscarProjetosUsuario", {
            params: { id_colaborador: userData.user.id_colaborador },
            headers: { "x-auth-token": token },
          });

          setNomeProjetos(response.data.resultSplit);
          setCliente(response.data.clientes);
        } catch (error) {
          console.error("Erro ao buscar Projetos:", error);
        }
      }
    };

    buscarProjetosClientes();
  }, [userData.user, ataId]);

  useEffect(() => {
    const buscarColaboradoresProjetoSelecionado = async () => {
      try {
        let token = localStorage.getItem("auth-token");
        const response = await api.get(
          "/api/buscarUsuariosProjeto/" + idProjeto,
          {
            headers: { "x-auth-token": token },
          }
        );
        setColaboradores(response.data.colaboradores);
      } catch (error) {
        console.error("Erro ao buscar Colaboradores:", error);
      }
    };

    if (idProjeto) {
      buscarColaboradoresProjetoSelecionado();
    }

    if (projetoSelected && ataId) {
      const projetoEncontrado = projeto?.find(
        (item) => item.nome_projeto === projetoSelected
      );
      setIdProjeto(projetoEncontrado?.id_projeto);
    }
  }, [idProjeto, ataId, projetoSelected, projeto]);

  const [decisoes, setDecisoes] = useState([
    {
      decisoes: "",
      itemReferente: "",
    },
  ]);

  const handleChange = (index, field, value) => {
    const newDecisoes = [...decisoes];
    newDecisoes[index][field] = value;
    setDecisoes(newDecisoes);
  };

  const handleChangeProximosPassos = (index, field, value) => {
    const newProximosPassos = [...proximosPassos];
    newProximosPassos[index][field] = value;
    setProximosPassos(newProximosPassos);
  };

  const handleAddFields = () => {
    setDecisoes([
      ...decisoes,
      {
        decisoes: "",
        itemReferente: "",
      },
    ]);
  };

  const handleRemoveFields = (index) => {
    if (decisoes.length > 1) {
      const newDecisoes = [...decisoes];
      newDecisoes.splice(index, 1);
      setDecisoes(newDecisoes);
    }
  };

  const abrirAta = (ata) => {
    history.push("/nova-ata/" + ata);
  };

  async function updateAta() {
    const data = {
      participantesFN,
      participantesClientes,
      pontosAbordados,
      decisoesTomadas: decisoes,
      proximosPassos,
    };
    try {
      await api.patch(`/api/ata/minhas/${ataId}`, data, {
        headers: { "X-Auth-Token": token, "content-type": "application/json" },
      });

      history.push("/documentos-ata");
    } catch (err) {
      alert.show(
        "Erro ao criar ao atualizar ata de reunião. Por favor, tente novamente.",
        { title: "Algo deu errado.", closeCopy: "OK" }
      );
    }

    toast({
      title: "Alteraçoes feitas foram salvas!",
    });
  }
  // async function abrirAta(ataId) {
  //   console.log(ataId);
  //   history.push(`/nova-ata/${ataId}`);
  // }

  async function submitHandler(e) {
    e.preventDefault();

    const data = {
      date: date,
      projeto: projetoSelected,
      cliente: clienteSelected,
      participantesFN,
      participantesClientes,
      pontosAbordados,
      decisoesTomadas: decisoes,
      proximosPassos,
      tempoInicial,
      tempoFinal,
      duracao,
    };

    if (
      !clienteSelected ||
      !projetoSelected ||
      !tempoInicial ||
      !tempoFinal ||
      !date
    ) {
      window.scrollTo({
        top: document.getElementById("camposObrigatorios").offsetTop,
        behavior: "smooth",
      });

      toast({
        title: "Por favor, preencha todos os campos obrigatórios",
        variant: "destructive",
        style: { backgroundColor: "#red" },
      });
      return; // Evita a execução do restante do código caso falte campos obrigatórios
    }

    try {
      const { data: resp } = await api.post("/api/ata/nova", data, {
        headers: { "X-Auth-Token": token, "content-type": "application/json" },
      });
      toast({
        // class:"bg-#1CC34B border-green",

        title: "Ata salva com sucesso",
        variant: "default",
        action: (
          <ToastAction altText="Abrir" onClick={() => abrirAta(resp._id)}>
            Abrir
          </ToastAction>
        ),
      });

      history.push("/documentos-ata");
    } catch (err) {
      toast({
        title: "Erro ao criar nova ata",
        variant: "destructive",
      });
    }
  }

  //FN
  const handleChangeInputFN = (index, value) => {
    const values = [...participantesFN];
    values[index]["emailFN"] = value;
    setParticipantesFN(values);
  };

  const handleAddFieldsFN = () => {
    setParticipantesFN([...participantesFN, { emailFN: "" }]);
  };

  const handleRemoveFieldsFN = (index) => {
    if (participantesFN.length > 1) {
      const values = [...participantesFN];
      values.splice(index, 1);
      setParticipantesFN(values);
    }
  };

  // Clientes
  const handleChangeInputClientes = (index, event) => {
    const values = [...participantesClientes];
    values[index]["emailCliente"] = event.target.value;
    setParticipantesClientes(values);
  };

  const handleAddFieldsClientes = () => {
    setParticipantesClientes([...participantesClientes, { emailCliente: "" }]);
  };

  const handleRemoveFieldsClientes = (index) => {
    const values = [...participantesClientes];
    values.splice(index, 1);
    setParticipantesClientes(values);
  };

  // Proximos passos
  const handleChangeInputProximosPassos = (index, event, field) => {
    const values = [...proximosPassos];
    const updatedValue = event && event.target ? event.target.value : event;
    values[index][field] = updatedValue;

    setProximosPassos(values);
  };

  const handleCancelarClick = () => {
    setIsModalOpen(true);
  };

  const handleConfirmarCancelamento = () => {
    setIsModalOpen(false);
    history.push("/documentos-ata");
  };

  const handleAddFieldsProximosPassos = () => {
    setProximosPassos([
      ...proximosPassos,
      {
        atividade: "",
        editorValue: "",
        responsavel: "",

        prazo: new Date(),
      },
    ]);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = (state) => {
    if (isModalOpen === false && isEnabledEditionMode) {
      console.warn("Nenhuma alteração para ser descartada");
      return;
    }
    setIsModalOpen(state);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleRemoveFieldsProximosPassos = (index) => {
    if (proximosPassos.length > 1) {
      const updatedProximosPassos = proximosPassos.filter(
        (_, i) => i !== index
      );
      setProximosPassos(updatedProximosPassos);
    }
  };

  const abrirDocumento = () => {
    history.push(`/ata-pdf/${ataId}?type=${isDocument ? 'documento' : 'ata'}`);
  };

  const [isEnabledEditionMode, setIsEnabledEditionMode] = useState(false);

  const handleHabilitarEdicao = () => {
    setLoading(false);
    setIsEnabledEditionMode((prev) => !prev);
    setTimeout(() => {
      setLoading(true);
    }, 200);
    toast({
      title: "Modo de edição desativado",
      description: "Você poderá alterar as informaçoes de sua ata",
    });
  };

  const handleDesabilitarEdicao = () => {
    setLoading(false);
    setIsEnabledEditionMode((prev) => !prev);
    setTimeout(() => {
      setLoading(true);
    }, 200);
    toast({
      title: "Modo de edição ativado",
      description: "Você poderá alterar as informaçoes de sua ata",
      // action: (
      //   <ToastAction altText="Desfazer" onClick={desfazerEdicao}>
      //     Desfazer
      //   </ToastAction>
      // ),
    });
  };

  const { setSteps } = useTour();

  useEffect(() => {
    if (ataId) {
      setSteps(stepsEdicaoAta);
    } else {
      setSteps(stepsNovaAta);
    }
  });

  const handleEnviarLixeira = async () => {
    try {
      try {
        await api.put(`/api/atas/${ataId}`);
      } catch (ataError) {
        // Fallback para documentos personalizados
        await api.post(`/documentos/${ataId}/trash`, null, {
          headers: { "X-Auth-Token": token },
        });
      }

      history.push("/atas-excluidas");

      toast({
        title: "Documento movido para lixeira",
        description: "Para recuperar ou remover o documento acesse a lixeira",
      });
    } catch (error) {
      console.error("Erro ao excluir documento:", error);
      toast({
        title: "Erro ao encaminhar para lixeira",
        variant: "destructive"
      });
    }
  };

  const pTituloStyle = {
    display: "flex",
    fontSize: "25px",
    fontStyle: "normal",
    fontWeight: "700",
    color: "#00293B",
    marginTop: "14px",
    // marginLeft: "45px",
    // marginRight: "45px",
    width: "100%",
  };

  return loading ? (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <nav
        className="navigation"
        style={{
          marginLeft: "20%",
          marginTop: "100px",
        }}
      >
        <ul>
          <li>
            <a href="/perfil">Home</a>
          </li>
          <li>/</li>
          <li>
            <a href="/documentos-ata">Atas</a>
          </li>
          <li>/</li>
          <li>
            {ataId ? (
              <a
                href={`/nova-ata/${clienteSelected}_${projetoSelected}_${ataId}`}
              >
                {clienteSelected}_{projetoSelected}-
                <Moment format="DD_MM_YYYY">{date}</Moment>
              </a>
            ) : (
              <p>Nova ata</p>
            )}
          </li>
        </ul>
      </nav>
      <div elevation={6} style={{ justifyContent: "center" }}>
        <div className="form-container1">
          <div
            style={{ width: "100%", paddingLeft: "15%", paddingRight: "15%" }}
          >
            <div
              id="titulo-e-icons"
              style={{
                display: "flex",
                flexDirection: "row",
                height: "120px",
                justifyContent: "center",
              }}
            >
              <Typography
                className={classes.titleStyle}
                align="center"
                variant="h5"
              >
                {ataId ? (
                  <div
                    id=""
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                    }}
                  >
                    <div style={{ paddingTop: "7px" }}>
                      <p
                        style={{ color: "#00293B", paddingTop: "0px" }}
                        className="titulo_ata_wrapper tituloEditarAta"
                      >
                        {clienteSelected}_{projetoSelected}-
                        <Moment format="DD_MM_YYYY">{date}</Moment>
                      </p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: "12px",
                        flexDirection: "row",
                        alignItems: "flex-end",
                        marginLeft: "10px",
                      }}
                    >
                      {isEnabledEditionMode ? (
                        <svg
                          className="buttonDesabilitarEdicao"
                          xmlns="http://www.w3.org/2000/svg"
                          width="33"
                          height="33"
                          viewBox="0 0 40 40"
                          fill="none"
                          onClick={handleHabilitarEdicao}
                          style={{
                            cursor: "pointer",
                            marginBottom: "12px",
                            marginRight: "-6px",
                            marginLeft: "13px",
                          }}
                        >
                          <path
                            d="M25.0001 10.0001L30.0001 15.0001M21.6667 33.3335H35.0001M8.33341 26.6668L6.66675 33.3335L13.3334 31.6668L32.6434 12.3568C33.2683 11.7317 33.6194 10.884 33.6194 10.0001C33.6194 9.11627 33.2683 8.26857 32.6434 7.64348L32.3567 7.35681C31.7317 6.73191 30.884 6.38086 30.0001 6.38086C29.1162 6.38086 28.2685 6.73191 27.6434 7.35681L8.33341 26.6668Z"
                            stroke="#6B6B6B"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      ) : (
                        <svg
                          className="buttonDesabilitarEdicao"
                          xmlns="http://www.w3.org/2000/svg"
                          width="33"
                          height="33"
                          viewBox="0 0 40 40"
                          fill="none"
                          onClick={handleDesabilitarEdicao}
                          style={{
                            cursor: "pointer",
                            marginBottom: "12px",
                            marginRight: "-10px",
                          }}
                        >
                          <path
                            d="M5.51185 4.25863C5.42955 4.17632 5.33184 4.11103 5.2243 4.06649C5.11677 4.02195 5.00151 3.99902 4.88512 3.99902C4.76872 3.99902 4.65347 4.02195 4.54593 4.06649C4.4384 4.11103 4.34069 4.17632 4.25838 4.25863C4.17608 4.34093 4.11079 4.43864 4.06625 4.54617C4.02171 4.65371 3.99878 4.76897 3.99878 4.88536C3.99878 5.00176 4.02171 5.11701 4.06625 5.22455C4.11079 5.33208 4.17608 5.42979 4.25838 5.5121L13.8135 15.0654L6.73523 22.1436C6.15573 22.7238 5.75349 23.457 5.57559 24.2575L4.02114 31.2508C3.98863 31.3963 3.9934 31.5476 4.035 31.6908C4.0766 31.834 4.15369 31.9643 4.25911 32.0697C4.36454 32.1752 4.49488 32.2523 4.63806 32.2939C4.78123 32.3355 4.93259 32.3402 5.0781 32.3077L12.0288 30.7621C12.8564 30.5779 13.6143 30.1615 14.2136 29.5618L21.2617 22.5154L30.815 32.0687C30.9812 32.2349 31.2067 32.3283 31.4417 32.3283C31.6768 32.3283 31.9022 32.2349 32.0685 32.0687C32.2347 31.9025 32.3281 31.677 32.3281 31.442C32.3281 31.2069 32.2347 30.9815 32.0685 30.8152L5.51185 4.25863ZM20.01 21.2619L12.9619 28.3101C12.6006 28.6718 12.1437 28.923 11.6447 29.0342L6.05007 30.277L7.30354 24.6417C7.408 24.169 7.64523 23.737 7.9887 23.3953L15.0652 16.3171L20.01 21.2619ZM27.09 14.1819L22.5134 18.7585L23.7651 20.0102L30.7814 12.994C31.7501 12.0024 32.2889 10.6688 32.2808 9.28256C32.2728 7.8963 31.7185 6.56911 30.7382 5.58886C29.758 4.60861 28.4308 4.05433 27.0445 4.04626C25.6583 4.03819 24.3247 4.57697 23.3331 5.54574L16.3169 12.562L17.5686 13.8137L22.1469 9.24065L27.09 14.1819ZM24.5848 6.79921C25.2447 6.16524 26.1269 5.81524 27.042 5.82433C27.957 5.83342 28.8321 6.20089 29.4793 6.84785C30.1265 7.49481 30.4942 8.36972 30.5037 9.28478C30.5131 10.1998 30.1634 11.0821 29.5297 11.7423L28.3417 12.9302L23.3968 7.98717L24.5848 6.79921Z"
                            fill="#6B6B6B"
                          />
                        </svg>
                      )}
                      <DownloadIcon
                        className="h-[60px] w-[30px] cursor-pointer buttonDownload"
                        onClick={abrirDocumento}
                        style={{ color: "rgb(63, 8, 220)" }}
                      />
                      <TrashIcon
                        className="h-[60px] w-[30px] cursor-pointer buttonExcluir"
                        onClick={handleEnviarLixeira}
                        style={{
                          color: "red",
                          marginLeft: "-7px",
                          marginTop: "-2px",
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <p
                    style={{ color: "#00293B", marginTop: "-90px" }}
                    className="titulo_ata_wrapper tituloNovaAta"
                  >
                    Nova Ata
                  </p>
                )}
              </Typography>
            </div>

            <div
              style={{
                width: "90%",
                marginLeft: "50px",
                borderBottom: "#0069988C 2px solid",
              }}
            >
              <a
                className="voltar"
                href="/documentos-ata"
                style={{ display: "flex", width: "6%" }}
              >
                <ArrowLeftIcon style={{ marginTop: "4px" }}></ArrowLeftIcon>
                Voltar
              </a>
            </div>

            {isDocument && Object.keys(customFields).length > 0 && (
              <div
                className="step-custom-fields"
                style={{
                  fontSize: "1rem",
                  fontFamily: "DM Sans",
                  fontWeight: 700,
                  width: "70rem",
                  padding: "5rem",
                  letterSpacing: "0.00938em",
                  margin: "0px",
                  borderRadius: "16px",
                  marginLeft: "15px",
                }}
              >
                <p style={pTituloStyle}>Campos do Documento</p>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px", marginTop: "20px" }}>
                  {Object.entries(customFields).map(([key, value]) => (
                    <div key={key} className="grid w-full max-w-sm items-center gap-1.5">
                      <Label style={{ color: "#000", textTransform: 'capitalize' }}>{key.replace(/_/g, ' ')}</Label>
                      <Input
                        style={{ color: "#000", width: "350px" }}
                        disabled={!isEnabledEditionMode}
                        value={value || ""}
                        onChange={(e) => handleCustomFieldChange(key, e.target.value)}
                        placeholder={`Valor para ${key}`}
                      />
                    </div>
                  ))}
                </div>
                <Divider className={classes.dividerStyle} variant="fullWidth" style={{ backgroundColor: "rgba(0, 105, 152, 0.55)", width: "50%", marginLeft: "250px" }} />
              </div>
            )}

            <div
              className="camposObrigatorios"
              style={{
                fontSize: "1rem",

                fontWeight: 700,
                width: "70rem",
                padding: "2rem",

                letterSpacing: "0.00938em",
                margin: "0px",
                borderRadius: "16px",

                marginLeft: "15px",
              }}
            >
              <p
                style={{
                  fontSize: "25px",
                  fontStyle: "normal",
                  fontWeight: "700",
                  color: "#00293B",
                  marginTop: "-4px",
                  marginLeft: "50px",
                }}
              >
                Informações Básicas *
              </p>

              <div
                style={{
                  display: "flex",
                  marginBottom: "1rem",
                  marginLeft: "45px",
                  gap: "10px",
                  marginTop: "98px",
                }}
                id="camposObrigatorios"
              >
                <fieldset
                  style={{
                    borderRadius: "4px",
                    borderColor: "#006998",
                    width: "200px",
                  }}
                >
                  <legend
                    style={{
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "black",
                      marginLeft: "8px",
                    }}
                  >
                    Data
                  </legend>
                  <Popover>
                    <PopoverTrigger className="data" asChild>
                      <Button
                        variant={"outline"}
                        className={cn(
                          "w-[250px] justify-start text-left font-normal",
                          !date && "text-muted-foreground"
                        )}
                      >
                        <CalendarIcon className="mr-2 h-4 w-4" />
                        {date ? (
                          format(date, "dd/MM/yyyy")
                        ) : (
                          <span>Selecione a data</span>
                        )}
                      </Button>
                    </PopoverTrigger>
                    <PopoverContent className="w-auto p-0">
                      <Calendar
                        mode="single"
                        required={true}
                        selected={date}
                        disabled={ataId}
                        initialFocus
                        onSelect={setDate}
                      />
                    </PopoverContent>
                  </Popover>
                </fieldset>
                <fieldset
                  style={{
                    borderRadius: "4px",
                    borderColor: "#E4E4E7",
                    width: "160x",
                  }}
                >
                  <legend
                    style={{
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "black",
                      marginLeft: "4px",
                    }}
                  >
                    Horário
                  </legend>
                  <DatePicker
                    className="border-e-2	horarioInicial"
                    style={{
                      borderColor: "#E4E4E7",

                      height: "2px",
                    }}
                    inputStyle={{
                      borderColor: "#E4E4E7",
                    }}
                    id="calendar-timeonly"
                    value={tempoInicial}
                    onChange={handleTempoInicialChange}
                    timeOnly
                    required
                    disabled={ataId}
                  />
                </fieldset>
                <fieldset
                  style={{
                    borderRadius: "4px",
                    borderColor: "#D7CFF9",
                    width: "160px",
                  }}
                >
                  <legend
                    style={{
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "black",
                      marginLeft: "8px",
                    }}
                  >
                    Horário
                  </legend>

                  <DatePicker
                    className="horarioFinal"
                    style={{
                      height: "10px",

                      borderRadius: 6,
                    }}
                    inputStyle={{
                      borderColor: "#E4E4E7",
                      height: "40px",
                    }}
                    id="calendar-timeonly"
                    value={tempoFinal}
                    onChange={handleTempoFinalChange}
                    timeOnly
                    disabled={ataId}
                  />
                </fieldset>

                <fieldset
                  style={{
                    borderRadius: "4px",
                    borderColor: "#006998",
                    width: "200px",
                    marginTop: "-1px",
                  }}
                >
                  <legend
                    style={{
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "black",
                      marginLeft: "-6px",
                      marginBottom: "-8px",
                    }}
                  >
                    {" "}
                    Duração
                  </legend>
                  <Button
                    variant="secondary"
                    className="p-button-outlined p-button-primary duracao"
                    style={{
                      color: "#B9BBC6",
                      borderRadius: "4px",
                      width: "160px",
                      height: "35px",
                      marginTop: "8px",
                      fontSize: "15px",
                    }}
                  >
                    {duracao !== null
                      ? `Duração: ${duracao} horas`
                      : "Duração: 0 horas"}
                  </Button>
                </fieldset>
              </div>

              <div
                style={{
                  display: "flex",
                  marginBottom: "1rem",
                  marginLeft: "45px",
                  gap: "10px",
                }}
              >
                <fieldset
                  style={{
                    borderRadius: "4px",
                    borderColor: "#006998",
                    width: "200px",
                  }}
                >
                  <legend
                    style={{
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    Clientes
                  </legend>
                  <Select
                    onValueChange={handleChangeCliente}
                    defaultValue={clienteSelected}
                    required
                    disabled={ataId}
                  >
                    <SelectTrigger className="w-[250px] clientes">
                      <SelectValue placeholder="Selecione o Cliente" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectGroup>
                        <option value="">Selecione o Cliente</option>
                        {cliente.map((cliente) => (
                          <SelectItem
                            key={cliente.nome_cliente}
                            value={cliente.nome_cliente}
                          >
                            {cliente.nome_cliente}
                          </SelectItem>
                        ))}
                      </SelectGroup>
                    </SelectContent>
                  </Select>
                </fieldset>
                <fieldset
                  style={{
                    borderRadius: "4px",
                    borderColor: "#006998",
                    width: "200px",
                  }}
                >
                  <legend
                    style={{
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "black",
                    }}
                  >
                    Projetos
                  </legend>
                  <Select
                    value={projetoSelected}
                    onValueChange={handleChangeProjeto}
                    disabled={!clienteSelected || ataId}
                    required
                  >
                    <SelectTrigger className="w-[250px] projetos">
                      <SelectValue placeholder="Selecione o Projeto" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectGroup>
                        <SelectLabel>Projeto</SelectLabel>
                        <option value="">Selecione o Projeto</option>
                        {projeto
                          .filter(
                            (proj) => proj.nome_cliente === clienteSelected
                          )
                          .map((projeto) => (
                            <SelectItem
                              key={projeto.id_projeto}
                              value={projeto.nome_projeto}
                            >
                              {`${projeto.nome_projeto}`}
                            </SelectItem>
                          ))}
                      </SelectGroup>
                    </SelectContent>
                  </Select>
                </fieldset>

                {/* <div style={{}} className="card flex justify-content-center">
                  <span
                    style={{
                      fontWeight: "400",
                      fontSize: "15px",
                      color: "black",
                    }}
                    className="p-float-label"
                  >
                    <Calendar
                      style={{
                        justifyContent: "center",
                        border: "none",
                        height: "10px",
                      }}
                      inputStyle={{
                        backgroundColor: "#F2FBFF",
                        border: "none",
                      }}
                      inputId="birth_date"
                      dateFormat="dd/mm/yy"
                      value={date}
                      onChange={(e) => setDate(e.value)}
                      required={true}
                      disabled={ataId}
                    />
                  </span>
                </div> */}
              </div>
            </div>
            <Divider
              className={classes.dividerStyle}
              variant="fullWidth"
              style={{
                backgroundColor: "rgba(0, 105, 152, 0.55)",
                width: "50%",
                marginLeft: "250px",
              }}
            />

            <div>
              <div
                className="step-participantes"
                style={{
                  fontSize: "1rem",
                  fontFamily: "DM Sans",
                  fontWeight: 700,
                  width: "70rem",
                  padding: "5rem",

                  letterSpacing: "0.00938em",
                  margin: "0px",
                  borderRadius: "16px",

                  marginLeft: "15px",
                }}
              >
                <p style={pTituloStyle}>Participantes</p>

                <div
                  id="field-titles"
                  style={{ display: "flex", width: "100%" }}
                >
                  <div id="fields-clientes" style={{ width: "50%" }}>
                    {/** Campo cliente */}
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "flex-start",
                        fontSize: "20px",
                        fontStyle: "normal",
                        fontWeight: "700",
                        color: "#00293B",
                        width: "50%",
                      }}
                    >
                      Cliente
                    </p>
                    {participantesClientes?.map((rowData, rowIndex) => (
                      <div
                        id="cliente-form"
                        key={rowIndex}
                        style={{
                          display: "flex",
                          marginTop: "10px",
                          marginBottom: "15px",
                          flexDirection: "row",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                          }}
                          className="grid w-full max-w-sm items-center gap-1.5"
                        >
                          <Label style={{ color: "#000" }}>Nome </Label>
                          <Input
                            className="participantesCliente"
                            style={{ color: "#000", width: "350px" }}
                            disabled={!isEnabledEditionMode}
                            value={rowData.emailCliente}
                            onChange={(e) =>
                              handleChangeInputClientes(rowIndex, e)
                            }
                            type="email"
                            id="email"
                            placeholder="Insira aqui o nome"
                          />
                        </div>
                        <div
                          id="icons"
                          style={{
                            display: "flex",
                            width: "20%",
                            marginTop: "20px",
                          }}
                        >
                          {isEnabledEditionMode || !ataId ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                marginRight: "10px",
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                onClick={() =>
                                  handleRemoveFieldsClientes(rowIndex)
                                }
                              >
                                <path
                                  d="M16.5 2.625V4.5H19.875C20.1734 4.5 20.4595 4.61853 20.6705 4.8295C20.8815 5.04048 21 5.32663 21 5.625C21 5.92337 20.8815 6.20952 20.6705 6.4205C20.4595 6.63147 20.1734 6.75 19.875 6.75H4.125C3.82663 6.75 3.54048 6.63147 3.3295 6.4205C3.11853 6.20952 3 5.92337 3 5.625C3 5.32663 3.11853 5.04048 3.3295 4.8295C3.54048 4.61853 3.82663 4.5 4.125 4.5H7.5V2.625C7.5 1.176 8.676 0 10.125 0H13.875C15.324 0 16.5 1.176 16.5 2.625ZM6.744 10.0125L7.734 19.9125C7.7433 20.0051 7.78668 20.0909 7.8557 20.1532C7.92473 20.2156 8.01447 20.2501 8.1075 20.25H15.8925C15.9855 20.2501 16.0753 20.2156 16.1443 20.1532C16.2133 20.0909 16.2567 20.0051 16.266 19.9125L17.256 10.0125C17.2932 9.72191 17.4423 9.45729 17.6715 9.27492C17.9008 9.09254 18.1922 9.00679 18.4837 9.0359C18.7752 9.06502 19.0439 9.20669 19.2325 9.43081C19.4212 9.65492 19.515 9.9438 19.494 10.236L18.504 20.136C18.4399 20.784 18.1371 21.3849 17.6544 21.8219C17.1716 22.2588 16.5436 22.5006 15.8925 22.5H8.1075C7.45681 22.4999 6.82935 22.2582 6.34681 21.8216C5.86428 21.3851 5.56107 20.7849 5.496 20.1375L4.506 10.2375C4.48721 10.0886 4.49843 9.93735 4.53899 9.7928C4.57954 9.64825 4.64862 9.51329 4.74215 9.39585C4.83568 9.27842 4.95177 9.18089 5.08358 9.10902C5.21539 9.03715 5.36024 8.99238 5.50962 8.97736C5.659 8.96235 5.80987 8.97738 5.95334 9.02157C6.09682 9.06577 6.23 9.13824 6.34503 9.2347C6.46007 9.33117 6.55463 9.44969 6.62315 9.58327C6.69167 9.71685 6.73276 9.86279 6.744 10.0125ZM9.75 2.625V4.5H14.25V2.625C14.25 2.52554 14.2105 2.43016 14.1402 2.35984C14.0698 2.28951 13.9745 2.25 13.875 2.25H10.125C10.0255 2.25 9.93016 2.28951 9.85983 2.35984C9.78951 2.43016 9.75 2.52554 9.75 2.625Z"
                                  fill="#EC0000"
                                />
                              </svg>

                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 22 22"
                                fill="none"
                                onClick={handleAddFieldsClientes}
                              >
                                <path
                                  d="M3.125 0.5H18.875C20.324 0.5 21.5 1.676 21.5 3.125V18.875C21.5 19.5712 21.2234 20.2389 20.7312 20.7312C20.2389 21.2234 19.5712 21.5 18.875 21.5H3.125C2.42881 21.5 1.76113 21.2234 1.26884 20.7312C0.776562 20.2389 0.5 19.5712 0.5 18.875V3.125C0.5 1.676 1.676 0.5 3.125 0.5ZM18.875 2.75H3.125C3.02554 2.75 2.93016 2.78951 2.85984 2.85984C2.78951 2.93016 2.75 3.02554 2.75 3.125V18.875C2.75 19.082 2.918 19.25 3.125 19.25H18.875C18.9745 19.25 19.0698 19.2105 19.1402 19.1402C19.2105 19.0698 19.25 18.9745 19.25 18.875V3.125C19.25 3.02554 19.2105 2.93016 19.1402 2.85984C19.0698 2.78951 18.9745 2.75 18.875 2.75ZM11 5C11.2984 5 11.5845 5.11853 11.7955 5.3295C12.0065 5.54048 12.125 5.82663 12.125 6.125V9.875H15.875C16.1734 9.875 16.4595 9.99353 16.6705 10.2045C16.8815 10.4155 17 10.7016 17 11C17 11.2984 16.8815 11.5845 16.6705 11.7955C16.4595 12.0065 16.1734 12.125 15.875 12.125H12.125V15.875C12.125 16.1734 12.0065 16.4595 11.7955 16.6705C11.5845 16.8815 11.2984 17 11 17C10.7016 17 10.4155 16.8815 10.2045 16.6705C9.99353 16.4595 9.875 16.1734 9.875 15.875V12.125H6.125C5.82663 12.125 5.54048 12.0065 5.3295 11.7955C5.11853 11.5845 5 11.2984 5 11C5 10.7016 5.11853 10.4155 5.3295 10.2045C5.54048 9.99353 5.82663 9.875 6.125 9.875H9.875V6.125C9.875 5.82663 9.99353 5.54048 10.2045 5.3295C10.4155 5.11853 10.7016 5 11 5Z"
                                  fill="#00293B"
                                />
                              </svg>
                            </div>
                          ) : (
                            <span style={{ marginBottom: "40px" }}></span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div id="fields-fn" style={{ width: "50%" }}>
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "flex-start",
                        fontSize: "20px",
                        fontStyle: "normal",
                        fontWeight: "700",
                        color: "#00293B",
                        width: "50%",
                      }}
                    >
                      Xerlock Smart Gov
                    </p>
                    {/** Campo Fabrica de Negocio*/}
                    {participantesFN?.map((rowData, rowIndex) => (
                      <div
                        key={rowIndex}
                        id="fabrica-form"
                        style={{
                          display: "flex",
                          marginTop: "10px",
                          marginBottom: "15px",
                          flexDirection: "row",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                          }}
                          className="grid w-full max-w-sm items-center gap-1.5"
                        >
                          <Label style={{ color: "#000" }}>Nome </Label>
                          <Select
                            value={rowData.emailFN}
                            onValueChange={(e) =>
                              handleChangeInputFN(rowIndex, e)
                            }
                            disabled={!isEnabledEditionMode}
                          >
                            <SelectTrigger className="w-[360px] participantesColaborador">
                              <SelectValue placeholder="Selecione o Colaborador" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectGroup>
                                <SelectLabel>Colaborador</SelectLabel>
                                <option value="">
                                  Selecione o Colaborador
                                </option>
                                {colaboradores?.map((colaborador) => (
                                  <SelectItem
                                    key={colaborador.id_colaborador}
                                    value={colaborador.name}
                                  >
                                    {colaborador.name}
                                  </SelectItem>
                                ))}
                              </SelectGroup>
                            </SelectContent>
                          </Select>
                        </div>
                        {isEnabledEditionMode || !ataId ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                              marginTop: "27px",
                              marginLeft: "8px",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              onClick={() => handleRemoveFieldsFN(rowIndex)}
                            >
                              <path
                                d="M16.5 2.625V4.5H19.875C20.1734 4.5 20.4595 4.61853 20.6705 4.8295C20.8815 5.04048 21 5.32663 21 5.625C21 5.92337 20.8815 6.20952 20.6705 6.4205C20.4595 6.63147 20.1734 6.75 19.875 6.75H4.125C3.82663 6.75 3.54048 6.63147 3.3295 6.4205C3.11853 6.20952 3 5.92337 3 5.625C3 5.32663 3.11853 5.04048 3.3295 4.8295C3.54048 4.61853 3.82663 4.5 4.125 4.5H7.5V2.625C7.5 1.176 8.676 0 10.125 0H13.875C15.324 0 16.5 1.176 16.5 2.625ZM6.744 10.0125L7.734 19.9125C7.7433 20.0051 7.78668 20.0909 7.8557 20.1532C7.92473 20.2156 8.01447 20.2501 8.1075 20.25H15.8925C15.9855 20.2501 16.0753 20.2156 16.1443 20.1532C16.2133 20.0909 16.2567 20.0051 16.266 19.9125L17.256 10.0125C17.2932 9.72191 17.4423 9.45729 17.6715 9.27492C17.9008 9.09254 18.1922 9.00679 18.4837 9.0359C18.7752 9.06502 19.0439 9.20669 19.2325 9.43081C19.4212 9.65492 19.515 9.9438 19.494 10.236L18.504 20.136C18.4399 20.784 18.1371 21.3849 17.6544 21.8219C17.1716 22.2588 16.5436 22.5006 15.8925 22.5H8.1075C7.45681 22.4999 6.82935 22.2582 6.34681 21.8216C5.86428 21.3851 5.56107 20.7849 5.496 20.1375L4.506 10.2375C4.48721 10.0886 4.49843 9.93735 4.53899 9.7928C4.57954 9.64825 4.64862 9.51329 4.74215 9.39585C4.83568 9.27842 4.95177 9.18089 5.08358 9.10902C5.21539 9.03715 5.36024 8.99238 5.50962 8.97736C5.659 8.96235 5.80987 8.97738 5.95334 9.02157C6.09682 9.06577 6.23 9.13824 6.34503 9.2347C6.46007 9.33117 6.55463 9.44969 6.62315 9.58327C6.69167 9.71685 6.73276 9.86279 6.744 10.0125ZM9.75 2.625V4.5H14.25V2.625C14.25 2.52554 14.2105 2.43016 14.1402 2.35984C14.0698 2.28951 13.9745 2.25 13.875 2.25H10.125C10.0255 2.25 9.93016 2.28951 9.85983 2.35984C9.78951 2.43016 9.75 2.52554 9.75 2.625Z"
                                fill="#EC0000"
                              />
                            </svg>

                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 22 22"
                              fill="none"
                              onClick={handleAddFieldsFN}
                            >
                              <path
                                d="M3.125 0.5H18.875C20.324 0.5 21.5 1.676 21.5 3.125V18.875C21.5 19.5712 21.2234 20.2389 20.7312 20.7312C20.2389 21.2234 19.5712 21.5 18.875 21.5H3.125C2.42881 21.5 1.76113 21.2234 1.26884 20.7312C0.776562 20.2389 0.5 19.5712 0.5 18.875V3.125C0.5 1.676 1.676 0.5 3.125 0.5ZM18.875 2.75H3.125C3.02554 2.75 2.93016 2.78951 2.85984 2.85984C2.78951 2.93016 2.75 3.02554 2.75 3.125V18.875C2.75 19.082 2.918 19.25 3.125 19.25H18.875C18.9745 19.25 19.0698 19.2105 19.1402 19.1402C19.2105 19.0698 19.25 18.9745 19.25 18.875V3.125C19.25 3.02554 19.2105 2.93016 19.1402 2.85984C19.0698 2.78951 18.9745 2.75 18.875 2.75ZM11 5C11.2984 5 11.5845 5.11853 11.7955 5.3295C12.0065 5.54048 12.125 5.82663 12.125 6.125V9.875H15.875C16.1734 9.875 16.4595 9.99353 16.6705 10.2045C16.8815 10.4155 17 10.7016 17 11C17 11.2984 16.8815 11.5845 16.6705 11.7955C16.4595 12.0065 16.1734 12.125 15.875 12.125H12.125V15.875C12.125 16.1734 12.0065 16.4595 11.7955 16.6705C11.5845 16.8815 11.2984 17 11 17C10.7016 17 10.4155 16.8815 10.2045 16.6705C9.99353 16.4595 9.875 16.1734 9.875 15.875V12.125H6.125C5.82663 12.125 5.54048 12.0065 5.3295 11.7955C5.11853 11.5845 5 11.2984 5 11C5 10.7016 5.11853 10.4155 5.3295 10.2045C5.54048 9.99353 5.82663 9.875 6.125 9.875H9.875V6.125C9.875 5.82663 9.99353 5.54048 10.2045 5.3295C10.4155 5.11853 10.7016 5 11 5Z"
                                fill="#00293B"
                              />
                            </svg>
                          </div>
                        ) : (
                          <span style={{ marginBottom: "40px" }}></span>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <Divider
                className={classes.dividerStyle}
                variant="fullWidth"
                style={{
                  backgroundColor: "rgba(0, 105, 152, 0.55)",
                  width: "50%",
                  marginLeft: "250px",
                }}
              />
              <div
                className="pontosAbordados"
                style={{
                  fontSize: "1rem",
                  fontFamily: "DM Sans",
                  fontWeight: 700,
                  width: "70rem",
                  padding: "5rem",

                  letterSpacing: "0.00938em",
                  margin: "0px",
                  borderRadius: "16px",

                  marginLeft: "15px",
                }}
              >
                <p
                  style={{
                    fontSize: "25px",
                    fontStyle: "normal",
                    fontWeight: "700",
                    color: "#00293B",
                    marginTop: "-4px",
                  }}
                >
                  Pontos Abordados
                </p>
                {pontosAbordados.map((pontoAbordado, index) => (
                  <div key={index}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div className="grid w-full max-w-sm items-center gap-1. pontosAbordadosItem">
                        <Label
                          style={{ color: "#000" }}
                          htmlFor={`item-${index}`}
                        >
                          Item{" "}
                        </Label>
                        <Input
                          style={{ color: "#000" }}
                          disabled={!isEnabledEditionMode}
                          value={pontoAbordado.item}
                          onChange={(e) => {
                            const updatedPontosAbordados = [...pontosAbordados];
                            updatedPontosAbordados[index].item = e.target.value;
                            setPontosAbordados(updatedPontosAbordados);
                          }}
                          type="email"
                          id="email"
                          placeholder="Insira aqui o nome do item"
                        />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          marginTop: "-36px",
                          gap: "5px",
                          marginLeft: "420px",
                        }}
                      >
                        {isEnabledEditionMode || !ataId ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                              marginTop: "2px",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              onClick={() => handleRemovePontoAbordado(index)}
                            >
                              <path
                                d="M16.5 2.625V4.5H19.875C20.1734 4.5 20.4595 4.61853 20.6705 4.8295C20.8815 5.04048 21 5.32663 21 5.625C21 5.92337 20.8815 6.20952 20.6705 6.4205C20.4595 6.63147 20.1734 6.75 19.875 6.75H4.125C3.82663 6.75 3.54048 6.63147 3.3295 6.4205C3.11853 6.20952 3 5.92337 3 5.625C3 5.32663 3.11853 5.04048 3.3295 4.8295C3.54048 4.61853 3.82663 4.5 4.125 4.5H7.5V2.625C7.5 1.176 8.676 0 10.125 0H13.875C15.324 0 16.5 1.176 16.5 2.625ZM6.744 10.0125L7.734 19.9125C7.7433 20.0051 7.78668 20.0909 7.8557 20.1532C7.92473 20.2156 8.01447 20.2501 8.1075 20.25H15.8925C15.9855 20.2501 16.0753 20.2156 16.1443 20.1532C16.2133 20.0909 16.2567 20.0051 16.266 19.9125L17.256 10.0125C17.2932 9.72191 17.4423 9.45729 17.6715 9.27492C17.9008 9.09254 18.1922 9.00679 18.4837 9.0359C18.7752 9.06502 19.0439 9.20669 19.2325 9.43081C19.4212 9.65492 19.515 9.9438 19.494 10.236L18.504 20.136C18.4399 20.784 18.1371 21.3849 17.6544 21.8219C17.1716 22.2588 16.5436 22.5006 15.8925 22.5H8.1075C7.45681 22.4999 6.82935 22.2582 6.34681 21.8216C5.86428 21.3851 5.56107 20.7849 5.496 20.1375L4.506 10.2375C4.48721 10.0886 4.49843 9.93735 4.53899 9.7928C4.57954 9.64825 4.64862 9.51329 4.74215 9.39585C4.83568 9.27842 4.95177 9.18089 5.08358 9.10902C5.21539 9.03715 5.36024 8.99238 5.50962 8.97736C5.659 8.96235 5.80987 8.97738 5.95334 9.02157C6.09682 9.06577 6.23 9.13824 6.34503 9.2347C6.46007 9.33117 6.55463 9.44969 6.62315 9.58327C6.69167 9.71685 6.73276 9.86279 6.744 10.0125ZM9.75 2.625V4.5H14.25V2.625C14.25 2.52554 14.2105 2.43016 14.1402 2.35984C14.0698 2.28951 13.9745 2.25 13.875 2.25H10.125C10.0255 2.25 9.93016 2.28951 9.85983 2.35984C9.78951 2.43016 9.75 2.52554 9.75 2.625Z"
                                fill="#EC0000"
                              />
                            </svg>

                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              onClick={() => handleAddPontoAbordado(index)}
                            >
                              <path
                                d="M4.125 1.5H19.875C21.324 1.5 22.5 2.676 22.5 4.125V19.875C22.5 20.5712 22.2234 21.2389 21.7312 21.7312C21.2389 22.2234 20.5712 22.5 19.875 22.5H4.125C3.42881 22.5 2.76113 22.2234 2.26884 21.7312C1.77656 21.2389 1.5 20.5712 1.5 19.875V4.125C1.5 2.676 2.676 1.5 4.125 1.5ZM19.875 3.75H4.125C4.02554 3.75 3.93016 3.78951 3.85984 3.85984C3.78951 3.93016 3.75 4.02554 3.75 4.125V19.875C3.75 20.082 3.918 20.25 4.125 20.25H19.875C19.9745 20.25 20.0698 20.2105 20.1402 20.1402C20.2105 20.0698 20.25 19.9745 20.25 19.875V4.125C20.25 4.02554 20.2105 3.93016 20.1402 3.85984C20.0698 3.78951 19.9745 3.75 19.875 3.75ZM12 6C12.2984 6 12.5845 6.11853 12.7955 6.3295C13.0065 6.54048 13.125 6.82663 13.125 7.125V10.875H16.875C17.1734 10.875 17.4595 10.9935 17.6705 11.2045C17.8815 11.4155 18 11.7016 18 12C18 12.2984 17.8815 12.5845 17.6705 12.7955C17.4595 13.0065 17.1734 13.125 16.875 13.125H13.125V16.875C13.125 17.1734 13.0065 17.4595 12.7955 17.6705C12.5845 17.8815 12.2984 18 12 18C11.7016 18 11.4155 17.8815 11.2045 17.6705C10.9935 17.4595 10.875 17.1734 10.875 16.875V13.125H7.125C6.82663 13.125 6.54048 13.0065 6.3295 12.7955C6.11853 12.5845 6 12.2984 6 12C6 11.7016 6.11853 11.4155 6.3295 11.2045C6.54048 10.9935 6.82663 10.875 7.125 10.875H10.875V7.125C10.875 6.82663 10.9935 6.54048 11.2045 6.3295C11.4155 6.11853 11.7016 6 12 6Z"
                                fill="#00293B"
                              />
                            </svg>
                          </div>
                        ) : (
                          <span style={{ marginBottom: "30px" }}></span>
                        )}
                      </div>
                    </div>
                    <div style={{ marginTop: "48px" }}>
                      {pontoAbordado?.editorValue ? (
                        // <Editor
                        //   readOnly={!isEnabledEditionMode}
                        //   id="1"
                        //   value={pontoAbordado.editorValue}
                        //   onTextChange={(e) => {
                        //     const updatedPontosAbordados = [...pontosAbordados];
                        //     updatedPontosAbordados[index].editorValue = e.textValue;
                        //     setPontosAbordados(updatedPontosAbordados);
                        //   }}
                        //   style={{
                        //     height: "152px",

                        //     background: "red",
                        //   }}
                        // />
                        <div className="grid w-full gap-1.5 pontosAbordadosDescricao">
                          <Label style={{ color: "#000" }}>
                            Descrição (opcional)
                          </Label>
                          <textarea
                            style={{
                              width: "50%",
                              color: "#000",
                              marginBottom: "20px",
                              border: "1px solid #CBD5E1",
                              borderRadius: "6px",
                              paddingLeft: "10px",
                            }}
                            readOnly={!isEnabledEditionMode}
                            id="1"
                            value={pontoAbordado.editorValue}
                            onChange={(e) => {
                              const updatedPontosAbordados = [
                                ...pontosAbordados,
                              ];
                              updatedPontosAbordados[index].editorValue =
                                e.target.value;
                              setPontosAbordados(updatedPontosAbordados);
                            }}
                            disabled={!isEnabledEditionMode}
                          />
                        </div>
                      ) : (
                        // <Editor
                        //   readOnly={!isEnabledEditionMode}
                        //   id="2"
                        //   value={""}
                        //   onTextChange={(e) => {
                        //     const updatedPontosAbordados = [...pontosAbordados];
                        //     updatedPontosAbordados[index].editorValue = e.textValue;
                        //     setPontosAbordados(updatedPontosAbordados);
                        //   }}
                        //   style={{
                        //     height: "152px",

                        //     background: "red",
                        //   }}
                        // />

                        <div className="grid w-full gap-1.5 pontosAbordadosDescricao">
                          <Label style={{ color: "#000" }} htmlFor="message">
                            Descrição (opcional)
                          </Label>
                          <textarea
                            style={{
                              width: "50%",
                              color: "#CBD5E1",
                              marginBottom: "20px",
                              border: "1px solid #CBD5E1",
                              borderRadius: "6px",
                              paddingLeft: "10px",
                            }}
                            readOnly={!isEnabledEditionMode}
                            id="2"
                            value={pontoAbordado.editorValue || ""}
                            onChange={(e) => {
                              const updatedPontosAbordados = [
                                ...pontosAbordados,
                              ];
                              updatedPontosAbordados[index].editorValue =
                                e.target.value;
                              setPontosAbordados(updatedPontosAbordados);
                            }}
                            disabled={!isEnabledEditionMode}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <Divider
                className={classes.dividerStyle}
                variant="fullWidth"
                style={{
                  backgroundColor: "rgba(0, 105, 152, 0.55)",
                  width: "50%",
                  marginLeft: "250px",
                }}
              />
              <div
                className="decisoesTomadas"
                style={{
                  color: "#3900DB",

                  fontSize: "1rem",

                  fontWeight: 700,
                  width: "70rem",
                  padding: "4rem",

                  letterSpacing: "0.00938em",
                  margin: "0px",
                  borderRadius: "16px",

                  marginLeft: "32px",
                }}
              >
                <p
                  style={{
                    fontSize: "25px",
                    fontStyle: "normal",
                    fontWeight: "700",
                    color: "#00293B",
                    marginTop: "-21px",
                  }}
                >
                  Decisões Tomadas
                </p>
                <div>
                  {decisoes.map((decisao, index) => (
                    <div key={index}>
                      <div
                        style={{
                          marginTop: "20px",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <div className="grid w-full max-w-sm items-center gap-1.5 decisoesTomadasDecisao">
                          <Label
                            style={{ color: "#000" }}
                            htmlFor={`decisoesTomadas-${index}`}
                          >
                            Decisão{" "}
                          </Label>
                          <Input
                            style={{
                              color: "#000",
                              marginBottom: "30px",
                            }}
                            disabled={!isEnabledEditionMode}
                            id={`decisoesTomadas-${index}`}
                            aria-describedby={`decisoesTomadas-help-${index}`}
                            value={decisao.decisoes}
                            onChange={(e) =>
                              handleChange(index, "decisoes", e.target.value)
                            }
                            placeholder="Insira aqui a decisão tomada"
                          />
                        </div>

                        <div
                          style={{
                            display: "flex",
                            marginTop: "-36px",
                            gap: "5px",
                            marginLeft: "422px",
                          }}
                        >
                          {isEnabledEditionMode || !ataId ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                marginTop: "2px",
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                onClick={() => handleRemoveFields(index)}
                              >
                                <path
                                  d="M16.5 2.625V4.5H19.875C20.1734 4.5 20.4595 4.61853 20.6705 4.8295C20.8815 5.04048 21 5.32663 21 5.625C21 5.92337 20.8815 6.20952 20.6705 6.4205C20.4595 6.63147 20.1734 6.75 19.875 6.75H4.125C3.82663 6.75 3.54048 6.63147 3.3295 6.4205C3.11853 6.20952 3 5.92337 3 5.625C3 5.32663 3.11853 5.04048 3.3295 4.8295C3.54048 4.61853 3.82663 4.5 4.125 4.5H7.5V2.625C7.5 1.176 8.676 0 10.125 0H13.875C15.324 0 16.5 1.176 16.5 2.625ZM6.744 10.0125L7.734 19.9125C7.7433 20.0051 7.78668 20.0909 7.8557 20.1532C7.92473 20.2156 8.01447 20.2501 8.1075 20.25H15.8925C15.9855 20.2501 16.0753 20.2156 16.1443 20.1532C16.2133 20.0909 16.2567 20.0051 16.266 19.9125L17.256 10.0125C17.2932 9.72191 17.4423 9.45729 17.6715 9.27492C17.9008 9.09254 18.1922 9.00679 18.4837 9.0359C18.7752 9.06502 19.0439 9.20669 19.2325 9.43081C19.4212 9.65492 19.515 9.9438 19.494 10.236L18.504 20.136C18.4399 20.784 18.1371 21.3849 17.6544 21.8219C17.1716 22.2588 16.5436 22.5006 15.8925 22.5H8.1075C7.45681 22.4999 6.82935 22.2582 6.34681 21.8216C5.86428 21.3851 5.56107 20.7849 5.496 20.1375L4.506 10.2375C4.48721 10.0886 4.49843 9.93735 4.53899 9.7928C4.57954 9.64825 4.64862 9.51329 4.74215 9.39585C4.83568 9.27842 4.95177 9.18089 5.08358 9.10902C5.21539 9.03715 5.36024 8.99238 5.50962 8.97736C5.659 8.96235 5.80987 8.97738 5.95334 9.02157C6.09682 9.06577 6.23 9.13824 6.34503 9.2347C6.46007 9.33117 6.55463 9.44969 6.62315 9.58327C6.69167 9.71685 6.73276 9.86279 6.744 10.0125ZM9.75 2.625V4.5H14.25V2.625C14.25 2.52554 14.2105 2.43016 14.1402 2.35984C14.0698 2.28951 13.9745 2.25 13.875 2.25H10.125C10.0255 2.25 9.93016 2.28951 9.85983 2.35984C9.78951 2.43016 9.75 2.52554 9.75 2.625Z"
                                  fill="#EC0000"
                                />
                              </svg>

                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                onClick={handleAddFields}
                              >
                                <path
                                  d="M4.125 1.5H19.8F75C21.324 1.5 22.5 2.676 22.5 4.125V19.875C22.5 20.5712 22.2234 21.2389 21.7312 21.7312C21.2389 22.2234 20.5712 22.5 19.875 22.5H4.125C3.42881 22.5 2.76113 22.2234 2.26884 21.7312C1.77656 21.2389 1.5 20.5712 1.5 19.875V4.125C1.5 2.676 2.676 1.5 4.125 1.5ZM19.875 3.75H4.125C4.02554 3.75 3.93016 3.78951 3.85984 3.85984C3.78951 3.93016 3.75 4.02554 3.75 4.125V19.875C3.75 20.082 3.918 20.25 4.125 20.25H19.875C19.9745 20.25 20.0698 20.2105 20.1402 20.1402C20.2105 20.0698 20.25 19.9745 20.25 19.875V4.125C20.25 4.02554 20.2105 3.93016 20.1402 3.85984C20.0698 3.78951 19.9745 3.75 19.875 3.75ZM12 6C12.2984 6 12.5845 6.11853 12.7955 6.3295C13.0065 6.54048 13.125 6.82663 13.125 7.125V10.875H16.875C17.1734 10.875 17.4595 10.9935 17.6705 11.2045C17.8815 11.4155 18 11.7016 18 12C18 12.2984 17.8815 12.5845 17.6705 12.7955C17.4595 13.0065 17.1734 13.125 16.875 13.125H13.125V16.875C13.125 17.1734 13.0065 17.4595 12.7955 17.6705C12.5845 17.8815 12.2984 18 12 18C11.7016 18 11.4155 17.8815 11.2045 17.6705C10.9935 17.4595 10.875 17.1734 10.875 16.875V13.125H7.125C6.82663 13.125 6.54048 13.0065 6.3295 12.7955C6.11853 12.5845 6 12.2984 6 12C6 11.7016 6.11853 11.4155 6.3295 11.2045C6.54048 10.9935 6.82663 10.875 7.125 10.875H10.875V7.125C10.875 6.82663 10.9935 6.54048 11.2045 6.3295C11.4155 6.11853 11.7016 6 12 6Z"
                                  fill="#00293B"
                                />
                              </svg>
                            </div>
                          ) : (
                            <span style={{ marginBottom: "40px" }}></span>
                          )}
                        </div>
                      </div>

                      <div className="grid w-full max-w-sm items-center gap-1.5 decisoesTomadasReferencia">
                        <Label
                          style={{ color: "#000" }}
                          htmlFor={`itemReferente-${index}`}
                        >
                          Item Referente{" "}
                        </Label>
                        <Input
                          style={{ color: "#000", marginBottom: "30px" }}
                          disabled={!isEnabledEditionMode}
                          id={`itemReferente-${index}`}
                          aria-describedby={`itemReferente-help-${index}`}
                          value={decisao.itemReferente} // TODO: Ajuste aqui
                          onChange={(e) =>
                            handleChange(index, "itemReferente", e.target.value)
                          }
                          placeholder="Insira aqui o nome do item referente"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <Divider
                className={classes.dividerStyle}
                variant="fullWidth"
                style={{
                  backgroundColor: "rgba(0, 105, 152, 0.55)",
                  width: "50%",
                  marginLeft: "250px",
                }}
              />

              <div style={{ marginLeft: "10px" }}>
                <div
                  className="proximosPassos"
                  style={{
                    fontSize: "1rem",

                    fontWeight: 700,
                    width: "70rem",
                    padding: "5rem",

                    letterSpacing: "0.00938em",
                    margin: "0px",
                    borderRadius: "16px",

                    justifyContent: "center",

                    marginLeft: "15px",
                  }}
                >
                  <p
                    style={{
                      fontSize: "25px",
                      fontStyle: "normal",
                      fontWeight: "700",
                      color: "#00293B",
                      marginTop: "-4px",
                    }}
                  >
                    Próximos passos
                  </p>
                  {proximosPassos?.map((atv, index) => (
                    <>
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 38,
                          marginTop: "30px",
                        }}
                      >
                        <fieldset
                          style={{
                            borderRadius: "4px",
                            borderColor: "#006998",
                            width: "200px",
                          }}
                        >
                          <legend
                            style={{
                              fontSize: "14px",
                              fontWeight: 500,
                            }}
                          >
                            Atividade
                          </legend>
                          <Select
                            disabled={!isEnabledEditionMode}
                            value={atv.atividade}
                            onValueChange={(e) =>
                              handleChangeInputProximosPassos(
                                index,
                                e,
                                "atividade"
                              )
                            }
                          >
                            <SelectTrigger className="w-[180px] proximosPassosAtividade">
                              <SelectValue placeholder="Atividade" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectGroup>
                                <SelectLabel>Selecione a Atividade</SelectLabel>

                                <SelectItem value="projeto">Projeto</SelectItem>
                                <SelectItem value="estudo">Estudo</SelectItem>
                                <SelectItem value="bug">Bug</SelectItem>
                                <SelectItem value="melhoria e projeto">
                                  Melhoria e Projeto
                                </SelectItem>
                              </SelectGroup>
                            </SelectContent>
                          </Select>
                        </fieldset>
                      </div>
                      <div
                        style={{ marginLeft: "200px", marginTop: "-56px" }}
                        className="grid w-full max-w-sm items-center gap-1.5"
                      >
                        <Label style={{ color: "#000", marginRight: "280px" }}>
                          Responsável
                        </Label>
                        <Select
                          value={atv.responsavel}
                          onValueChange={(e) =>
                            handleChangeInputProximosPassos(
                              index,
                              e,
                              "responsavel"
                            )
                          }
                          disabled={!isEnabledEditionMode}
                        >
                          <SelectTrigger className="w-[360px] proximosPassosResponsavel">
                            <SelectValue placeholder="Selecione o Responsável" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectGroup>
                              <SelectLabel>Responsável</SelectLabel>
                              <option value="">Selecione o Responsável</option>
                              {colaboradores?.map((colaborador) => (
                                <SelectItem
                                  key={colaborador.id_colaborador}
                                  value={colaborador.name}
                                >
                                  {colaborador.name}
                                </SelectItem>
                              ))}
                            </SelectGroup>
                          </SelectContent>
                        </Select>
                        {/* <Input
                          style={{ color: "#000" }}
                          disabled={!isEnabledEditionMode}
                          value={atv.responsavel}
                          onChange={(e) =>
                            handleChangeInputProximosPassos(
                              index,
                              e,
                              "responsavel"
                            )
                          }
                          placeholder="Digite o responsável"
                        /> */}
                      </div>

                      <div
                        style={{
                          display: "flex",
                          marginTop: "-59px",
                          gap: "5px",
                          marginLeft: "600px",
                        }}
                      >
                        {isEnabledEditionMode || !ataId ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                              marginTop: "27px",
                              marginLeft: "8px",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              onClick={() =>
                                handleRemoveFieldsProximosPassos(index)
                              }
                            >
                              <path
                                d="M16.5 2.625V4.5H19.875C20.1734 4.5 20.4595 4.61853 20.6705 4.8295C20.8815 5.04048 21 5.32663 21 5.625C21 5.92337 20.8815 6.20952 20.6705 6.4205C20.4595 6.63147 20.1734 6.75 19.875 6.75H4.125C3.82663 6.75 3.54048 6.63147 3.3295 6.4205C3.11853 6.20952 3 5.92337 3 5.625C3 5.32663 3.11853 5.04048 3.3295 4.8295C3.54048 4.61853 3.82663 4.5 4.125 4.5H7.5V2.625C7.5 1.176 8.676 0 10.125 0H13.875C15.324 0 16.5 1.176 16.5 2.625ZM6.744 10.0125L7.734 19.9125C7.7433 20.0051 7.78668 20.0909 7.8557 20.1532C7.92473 20.2156 8.01447 20.2501 8.1075 20.25H15.8925C15.9855 20.2501 16.0753 20.2156 16.1443 20.1532C16.2133 20.0909 16.2567 20.0051 16.266 19.9125L17.256 10.0125C17.2932 9.72191 17.4423 9.45729 17.6715 9.27492C17.9008 9.09254 18.1922 9.00679 18.4837 9.0359C18.7752 9.06502 19.0439 9.20669 19.2325 9.43081C19.4212 9.65492 19.515 9.9438 19.494 10.236L18.504 20.136C18.4399 20.784 18.1371 21.3849 17.6544 21.8219C17.1716 22.2588 16.5436 22.5006 15.8925 22.5H8.1075C7.45681 22.4999 6.82935 22.2582 6.34681 21.8216C5.86428 21.3851 5.56107 20.7849 5.496 20.1375L4.506 10.2375C4.48721 10.0886 4.49843 9.93735 4.53899 9.7928C4.57954 9.64825 4.64862 9.51329 4.74215 9.39585C4.83568 9.27842 4.95177 9.18089 5.08358 9.10902C5.21539 9.03715 5.36024 8.99238 5.50962 8.97736C5.659 8.96235 5.80987 8.97738 5.95334 9.02157C6.09682 9.06577 6.23 9.13824 6.34503 9.2347C6.46007 9.33117 6.55463 9.44969 6.62315 9.58327C6.69167 9.71685 6.73276 9.86279 6.744 10.0125ZM9.75 2.625V4.5H14.25V2.625C14.25 2.52554 14.2105 2.43016 14.1402 2.35984C14.0698 2.28951 13.9745 2.25 13.875 2.25H10.125C10.0255 2.25 9.93016 2.28951 9.85983 2.35984C9.78951 2.43016 9.75 2.52554 9.75 2.625Z"
                                fill="#EC0000"
                              />
                            </svg>

                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 22 22"
                              fill="none"
                              onClick={handleAddFieldsProximosPassos}
                            >
                              <path
                                d="M3.125 0.5H18.875C20.324 0.5 21.5 1.676 21.5 3.125V18.875C21.5 19.5712 21.2234 20.2389 20.7312 20.7312C20.2389 21.2234 19.5712 21.5 18.875 21.5H3.125C2.42881 21.5 1.76113 21.2234 1.26884 20.7312C0.776562 20.2389 0.5 19.5712 0.5 18.875V3.125C0.5 1.676 1.676 0.5 3.125 0.5ZM18.875 2.75H3.125C3.02554 2.75 2.93016 2.78951 2.85984 2.85984C2.78951 2.93016 2.75 3.02554 2.75 3.125V18.875C2.75 19.082 2.918 19.25 3.125 19.25H18.875C18.9745 19.25 19.0698 19.2105 19.1402 19.1402C19.2105 19.0698 19.25 18.9745 19.25 18.875V3.125C19.25 3.02554 19.2105 2.93016 19.1402 2.85984C19.0698 2.78951 18.9745 2.75 18.875 2.75ZM11 5C11.2984 5 11.5845 5.11853 11.7955 5.3295C12.0065 5.54048 12.125 5.82663 12.125 6.125V9.875H15.875C16.1734 9.875 16.4595 9.99353 16.6705 10.2045C16.8815 10.4155 17 10.7016 17 11C17 11.2984 16.8815 11.5845 16.6705 11.7955C16.4595 12.0065 16.1734 12.125 15.875 12.125H12.125V15.875C12.125 16.1734 12.0065 16.4595 11.7955 16.6705C11.5845 16.8815 11.2984 17 11 17C10.7016 17 10.4155 16.8815 10.2045 16.6705C9.99353 16.4595 9.875 16.1734 9.875 15.875V12.125H6.125C5.82663 12.125 5.54048 12.0065 5.3295 11.7955C5.11853 11.5845 5 11.2984 5 11C5 10.7016 5.11853 10.4155 5.3295 10.2045C5.54048 9.99353 5.82663 9.875 6.125 9.875H9.875V6.125C9.875 5.82663 9.99353 5.54048 10.2045 5.3295C10.4155 5.11853 10.7016 5 11 5Z"
                                fill="#00293B"
                              />
                            </svg>
                          </div>
                        ) : (
                          <span style={{ marginBottom: "40px" }}></span>
                        )}
                      </div>

                      {/* <div
                    className="card"
                    style={{ marginLeft: "53px", marginTop: "46px" }}
                  >
                    <Editor
                      readOnly={!isEnabledEditionMode}
                      value={atv.editorValue}
                      onTextChange={(e) => {
                        const updatedproximosPassos = [...proximosPassos];
                        updatedproximosPassos[index].editorValue = e.textValue;
                        setProximosPassos(updatedproximosPassos);
                      }}
                      style={{ height: "150px" }}
                    />
                  </div> */}

                      <div className="grid w-full gap-1.5 proximosPassosDescricao">
                        <Label
                          style={{
                            color: "#000",
                            marginRight: "987px",
                            marginTop: "30px",
                          }}
                          htmlFor="message"
                        >
                          Descrição
                        </Label>
                        {/* <Textarea
                      style={{ width: "50%", color: "#000", marginBottom:"20px"}}
                      readOnly={!isEnabledEditionMode}
                      value={atv.editorValue}
                      onTextChange={(e) => {
                        const updatedproximosPassos = [...proximosPassos];
                      
                        updatedproximosPassos[index].editorValue = e.target.textValue;
                        setProximosPassos(updatedproximosPassos);
                      }}
                      placeholder="Descrição"
                      id="message"
                    /> */}

                        <textarea
                          style={{
                            width: "50%",
                            color: "#000",
                            marginBottom: "20px",
                            border: "1px solid #CBD5E1",
                            borderRadius: "6px",
                            paddingLeft: "10px",
                          }}
                          value={atv.editorValue}
                          onChange={(e) => {
                            const updatedProximosPassos = [...proximosPassos];
                            updatedProximosPassos[index].editorValue =
                              e.target.value;
                            setProximosPassos(updatedProximosPassos);
                          }}
                          id="message"
                          disabled={!isEnabledEditionMode}
                        />
                      </div>
                      <div className="grid w-full max-w-sm items-center gap-1.5 proximosPassosAtividadesDoTaiga">
                        <Label
                          style={{ color: "#000" }}
                          htmlFor={`linkAtividades-${index}`}
                        >
                          Link Atividades do Taiga{" "}
                        </Label>
                        <Input
                          style={{ color: "#000", marginBottom: "30px" }}
                          disabled={!isEnabledEditionMode}
                          id={`linkAtividades-${index}`}
                          aria-describedby={`linkAtividades-help-${index}`}
                          value={atv.linkAtividades} // TODO: Ajuste aqui
                          onChange={(e) =>
                            handleChangeProximosPassos(
                              index,
                              "linkAtividades",
                              e.target.value
                            )
                          }
                          type="email"
                          placeholder="Insira aqui o link"
                        />
                      </div>

                      <fieldset
                        style={{
                          borderRadius: "4px",
                          borderColor: "#006998",
                          width: "200px",
                        }}
                      >
                        <legend
                          style={{
                            fontSize: "14px",
                            fontWeight: 500,
                            color: "black",
                          }}
                        >
                          Prazo
                        </legend>
                        <Popover>
                          <PopoverTrigger
                            className="proximosPassosPrazo"
                            asChild
                          >
                            <Button
                              variant={"outline"}
                              className={cn(
                                "w-[280px] justify-start text-left font-normal",
                                !date && "text-muted-foreground"
                              )}
                            >
                              <CalendarIcon className="mr-2 h-4 w-4" />
                              {atv.prazo ? (
                                format(atv.prazo, "dd/MM/yyyy")
                              ) : (
                                <span>Selecione o prazo</span>
                              )}
                            </Button>
                          </PopoverTrigger>
                          <PopoverContent className="w-auto p-0">
                            <Calendar
                              mode="single"
                              onSelect={(e) =>
                                handleChangeInputProximosPassos(
                                  index,
                                  e,
                                  "prazo"
                                )
                              }
                              required={true}
                              selected={atv.prazo}
                              disabled={!isEnabledEditionMode}
                              initialFocus
                            />
                          </PopoverContent>
                        </Popover>
                      </fieldset>
                    </>
                  ))}

                  <div
                    style={{
                      display: "flex",
                      marginLeft: "700px",
                      marginTop: "30px",
                    }}
                  >
                    <AlertDialog open={isModalOpen} onOpenChange={openModal}>
                      <AlertDialogTrigger>
                        <div style={{ marginRight: "10px" }}>
                          {isEnabledEditionMode || !ataId ? (
                            <Button
                              className="buttonCancelar"
                              variant="outline"
                              style={{ color: "#373737", fontWeight: "600" }}
                              onClick={handleCancelarClick}
                            >
                              Cancelar
                            </Button>
                          ) : (
                            <span></span>
                          )}
                        </div>
                      </AlertDialogTrigger>

                      <AlertDialogContent
                        style={{
                          width: "600px",
                          // borderColor: "red",
                          fontWeight: "600",
                          color: "black",
                          overflowY: "visible",
                          boxShadow: "rgb(0 0 0) 0px 3px 3px 0px",
                        }}
                      >
                        <AlertDialogHeader>
                          <div className="p-d-flex p-ai-center">
                            <AlertDialogTitle
                              style={{
                                color: "#EC0000",
                                fontSize: "32px",
                                marginTop: "-65px",
                                display: "flex",
                                justifyContent: "center",
                                paddingTop: "65px",
                                fontWeight: "400",
                              }}
                            >
                              Atenção
                            </AlertDialogTitle>
                          </div>
                        </AlertDialogHeader>
                        <AlertDialogDescription
                          style={{
                            color: "black",
                            fontWeight: "400",
                            fontSize: "16px",
                            marginTop: "10px",
                            marginBottom: "-20px",
                          }}
                        >
                          Você tem alterações não salvas. Deseja sair assim
                          mesmo?
                          <br></br>
                          Caso saia suas{" "}
                          <b style={{ fontWeight: "700" }}>
                            alterações serão perdidas.
                          </b>
                          <br></br>
                        </AlertDialogDescription>
                        <AlertDialogFooter
                          style={{
                            marginTop: "40px",
                            marginLeft: "150px",
                            display: "flex",
                            position: "static",
                          }}
                        >
                          <AlertDialogCancel
                            className="p-button-outlined p-button-primary"
                            style={{
                              color: "black",
                              display: "flex",
                              justifyContent: "center",
                              fontSize: "13px",
                              fontWeight: "300",
                              borderColor: "#000000b8",
                            }}
                            onClick={closeModal}
                          >
                            Cancelar
                          </AlertDialogCancel>
                          <AlertDialogAction
                            className="p-button-outlined p-button-primary"
                            style={{
                              color: "white",
                              fontWeight: "300",
                              backgroundColor: "red",
                              fontSize: "13px",
                              width: "173px",
                              marginRight: "10px",
                            }}
                            onClick={() => handleConfirmarCancelamento()}
                          >
                            Sair assim mesmo
                          </AlertDialogAction>
                        </AlertDialogFooter>
                      </AlertDialogContent>
                    </AlertDialog>

                    {/* <Dialog
                      visible={mostrarModal}
                      style={{
                        width: "450px",
                        borderColor: "red",
                        fontWeight: "600",
                        color: "black",
                      }}
                      onHide={() => setMostrarModal(false)}
                    >
                      <div className="p-d-flex p-ai-center">
                        <i
                          className="pi pi-exclamation-triangle p-mr-2"
                          style={{
                            fontSize: "3rem",
                            color: "#EC0000",
                            marginTop: "-2px",
                            marginLeft: "100px",
                          }}
                        />
                        <h5
                          style={{
                            color: "#EC0000",
                            fontSize: "20px",
                            marginTop: "-43px",
                            marginLeft: "160px",
                          }}
                        >
                          Atenção !
                        </h5>
                      </div>

                      <p style={{ fontWeight: "400" }}>
                        Você tem alterçoes não salvas. Deseja sair assim mesmo?
                        Caso saia suas{" "}
                        <strong>alterações serão perdidas.</strong>
                      </p>
                      <div
                        style={{
                          marginTop: "40px",
                          marginLeft: "190px",
                          gap: "1rem",
                          display: "flex",
                        }}
                      >
                        <Button
                          label="Cancelar"
                          className="p-button-outlined p-button-primary"
                          style={{ color: "red", fontWeight: "600" }}
                          onClick={handleCancelarModal}
                        />

                        <Button
                          label="Sair"
                          className="p-button-outlined p-button-primary"
                          style={{
                            color: "white",
                            fontWeight: "600",
                            backgroundColor: "red",
                          }}
                          onClick={handleConfirmarCancelamento}
                        />
                      </div>
                    </Dialog> */}

                    <div>
                      {isEnabledEditionMode || !ataId ? (
                        <Button
                          label={ataId ? "Salvar" : "Criar ata"}
                          className="p-button-outlined p-button-primary buttonCriarEditar"
                          style={{
                            color: "#FFF",
                            fontSize: "16px",
                            backgroundColor: "#3900DB",
                            fontWeight: "600",
                          }}
                          onClick={ataId ? updateAta : submitHandler}
                        >
                          {ataId ? "Salvar" : "Criar ata"}
                        </Button>
                      ) : (
                        <span></span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ marginTop: "-18.5rem" }}>
          <Tour></Tour>
        </div>
      </div>
    </div>
  ) : (
    <h1>Carregando...</h1>
  );
}

export default NovaAta;
